import { makeStyles } from '@material-ui/core/styles'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: '100%',
    position: 'relative',
    flex: '1 1 auto',
    height: '75vh',
    backgroundColor: theme.palette.background.default,
  },
  contentCardWrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    width: '100%',
    maxWidth: '100%',
    minWidth: '0',
    maxHeight: '100%',
    margin: '0 10',
    [theme.breakpoints.down('sm')]: {
      padding: 16,
    },
    [theme.breakpoints.down('xs')]: {
      padding: 12,
    },
  },
  contentCard: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 100%',
    flexDirection: 'row',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    minHeight: 0,
    overflow: 'hidden',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 100%',
    zIndex: 10,
    backgroundColor: '#f9f9f9',
  },
  content: {
    display: 'flex',
    flex: '1 1 100%',
    minHeight: 0,
  },
  drawerPaper: {
    width: '480px',
    maxWidth: '100%',
    overflow: 'hidden',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  groupActionDeleteDiv: {
    color: '#f74872',
    fontSize: 13,
    '& .MuiListItemIcon-root': {
      minWidth: 28,
    },
    '& span': {
      color: '#f74872',
    },
  },
  deleteIcon: {
    cursor: 'pointer',
  },
  morevertIcon: {
    color: theme.palette.grey.morevertIcon,
  },
  tableContent: {
    position: 'relative',
    '& .rt-thead': {
      position: 'sticky',
      left: 0,
      zIndex: 0,
    },
    '& .rt-tbody': {
      overflow: 'visible !important',
    },
    '& .rt-tbody .rt-tr:not(.-padRow):hover .fixBackground': {
      background: '#ececec',
    },
  },
  tableWithFilters: {
    '& .rt-tbody': {
      marginTop: 1,
    },
    '& .filter': {
      width: 120,
      '& .material-icons': {
        fontSize: '2.4rem !important',
      },
      '& .MuiInputBase-adornedEnd': {
        padding: '8px 0',
      },
      '& .MuiInputBase-inputAdornedEnd': {
        color: '#a8a8a8',
        fontSize: '12px !important',
      },
      '& .MuiFormHelperText-root': {
        fontSize: 10,
        marginTop: 4,
        color: '#a8a8a8',
      },
      '& .MuiInput-underline:before': {
        borderColor: '#a8a8a8',
      },
    },
  },
  tableContentEmpty: {
    padding: 50,
  },
  createBtn: {
    float: 'right',
    marginTop: 25,
    backgroundColor: '#0073b1',
    marginBottom: 25,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0073b1',
    },
  },
  emptyTextOne: {
    color: '#a8a8a8',
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 15,
  },
  createBtnSecond: {
    marginTop: 24,
    fontSize: 12,
    backgroundColor: '#0073b1',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#0073b1',
    },
    '& span': {
      marginLeft: 8,
    },
  },
  emptyIconOne: {
    color: '#a8a8a8',
    '& i': {
      fontSize: 156,
    },
  },
  gridEmpty: {
    minHeight: '-webkit-fill-available',
  },
  paper: {
    marginTop: 20,
    padding: 15,
  },
  cardWrapp: {},
  addSubConversationBtn: {
    color: '#fff',
    right: -17,
    bottom: 0,
    margin: 'auto',
    top: 0,
    position: 'absolute',
    zIndex: 99,
  },
  card: {
    position: 'relative',
    minWidth: 275,
    marginBottom: 15,
  },
  cardTitle: {
    marginLeft: 28,
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 25,
  },
  card_info: {
    overflow: 'inherit',
  },
  subgroups: {
    fontSize: 14,
  },
  card_one_actions: {
    alignItems: 'start',
    '& button': {
      justifyContent: 'start',
    },
  },
  card_one_info: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  dialog_one_title: {
    fontWeight: 'bold',
  },
  dialog_one_title_wrapp: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
  dialogActionBtnsStyleOne: {
    marginTop: 15,
  },
  icons_one: {
    fontSize: 16,
    marginRight: 3,
  },
  subgroup_item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomRightRadius: '50px',
    borderTopRightRadius: '50px',
    padding: '9px 28px',
    paddingRight: '10px',
    background: 'transparent',
    color: 'black',
    marginRight: 20,
    marginBottom: 0,
    fontSize: 14,
    [useBreakpoints(theme).lessThan.lg]: {
      '&.active .subgroup_item_action_btn': {
        display: 'inline-block',
      },
    },
  },
  subgroup_item_add: {
    color: theme.palette.secondary.main,
    marginTop: 8,
  },
  subgroup_item_hover: {
    '&:hover': {
      background: theme.palette.grey.light,
    },
    '&.active': {
      background: theme.palette.secondary.main,
      color: 'white',
    },
  },
  subgroup_item_title: {
    flex: 1,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  subgroup_item_action_btn: {
    display: 'none',
    height: 16,
    '& span': {
      cursor: 'pointer',
    },
  },
  subgroup_item_icon: {
    fontSize: '1.6rem',
  },
  subgroup_item_text: {
    marginLeft: '8px',
    marginRight: '6px',
    lineHeight: '14px',
  },
  input_new_group_title: {
    padding: '16px 24px 0 24px',
    fontSize: 16,
  },
  detailsTable: {
    flex: 1,
    margin: '0 0 0 22px',
    flexDirection: 'column',
    backgroundColor: '#fff',
    height: 'fit-content',
    '& .ReactTable': {
      border: 0,
    },
    '@media(max-width:600px)': {
      margin: 0,
    },
  },
  dialog_root: {
    overflow: 'visible',
  },
  snackbar_success: {
    backgroundColor: '#008000',
    borderRadius: '50px',
  },
  table_detail: {
    width: '100%',
    textAlign: 'left !important',
  },
  tableNoData: {
    position: 'absolute',
    display: 'flex',
    top: '2px',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      marginTop: 20,
      marginBottom: 12,
    },
  },
  toolbar_group_page: {
    backgroundColor: '#fff',
    justifyContent: 'space-between',
  },
  tableItemName: {
    fontWeight: 'bold',
    fontFamily: `Roboto,"Helvetica",Arial,sans-serif !important`,
  },
  searchBox: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid black',
    borderRadius: '4px',
    padding: '4px',
    paddingLeft: '6px',
  },
  searchBoxInput: {
    background: 'transparent',
  },
  mediumIcon: {
    fontSize: '3rem',
    cursor: 'pointer',
  },
  pageHeader: {
    display: 'flex',
    width: '100%',
    paddingLeft: '2.4rem',
  },
  pageInfos: {
    display: 'flex',
    alignItems: 'center',
  },
  spaceRight: {
    marginRight: 16,
    marginTop: 5,
  },
  backToAll: {
    color: theme.palette.secondary.main,
    display: 'inline-flex',
    alignItems: 'center',
  },
  backToAllText: {
    lineHeight: '1.4',
  },
  groupButton: {
    textTransform: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    fontColor: 'rgba(0, 0, 0, 0.54)',
  },
  firstConversationButton: {
    paddingLeft: 0,
  },
  buttonIcon: {
    fontSize: '2.4rem',
    marginRight: 4,
  },
  deleteBtn: {
    backgroundColor: '#f74872',
    '&:hover': {
      backgroundColor: '#f74872',
      borderColor: '#f74872',
    },
    '&:focus': {},
  },
  groupActionBtns: {
    padding: '8px 30px',
  },
  actionBtnsQWrapp: {
    padding: '8px 25px',
  },
  actionBtn: {
    backgroundColor: '#0073b1',
    '&:hover': {
      backgroundColor: '#0073b1',
      borderColor: '#0073b1',
    },
    '&:focus': {},
  },
  groupDialogTwo: {
    '& .MuiPaper-root': {
      // padding: '24px 15px 8px 15px',
    },
  },
  groupDialogStyleOne: {
    '& .MuiPaper-root': {
      maxWidth: 422,
    },
  },
  groupDialogStylTwo: {
    '& .MuiPaper-root': {
      minWidth: 410,
    },
  },
  subgroupCardContent: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 15,
    paddingBottom: 10,
  },
  group_info: {
    marginTop: 16,
    paddingTop: 32,
    paddingBottom: 12,
  },
  groupInfoTitle: {
    marginBottom: 24,
    fontSize: 24,
    color: '#0f3040',
    fontWeight: 'bold',
  },
  group_info_counts: {
    marginBottom: 10,
  },
  renameActionBtns: {
    paddingRight: 24,
  },
  langItem: {
    color: '#0073b1',
    fontSize: 16,
    marginTop: 5,
  },
  subConversationTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingLeft: 24,
    paddingBottom: 15,
    boxShadow: '0px 15px 12px -14px rgba(0, 0, 0, 0.05)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
  },
  detachIcon: {
    cursor: 'pointer',
    color: 'red',
  },
  deleteTabBtn: {
    color: '#f74872',
    '& span': {
      color: '#f74872',
    },
  },
  exportTabBtn: {
    color: '#0073b1',
    '& span': {
      color: '#0073b1',
    },
  },
  pageHeaderRightBar: {
    display: 'flex',
    flexDirection: 'initial',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '2.4rem',
  },
  groupsLanguagesTitle: {
    fontSize: 16,
    color: '#0f3040',
    fontWeight: 'bold',
  },
  noConversationsMsg: {
    textAlign: 'center',
    fontSize: 24,
    marginTop: 50,
    fontWeight: 'bold',
  },
  tableNoSubscribers: {
    textAlign: 'center',
    padding: 45,
    color: '#0f3040',
  },
  link: {
    color: `${theme.palette.secondary.main} !important`,
    textDecoration: 'none !important',
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none !important',
    },
  },
  normalText: {
    color: theme.palette.textHighlight.main,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  deleteMenu: {
    color: theme.palette.negative.main,
  },
  groupName: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#404040',
  },
  fixBackground: {
    background: '#f9f9f9',
    zIndex: 2,
  },
  fixBackgroundSecondary: {
    background: '#fff',
    zIndex: 2,
  },
  tablePanel: {
    marginBottom: 16,
  },
  linkToWithoutSubscribers: {
    fontSize: 14,
    color: '#0073b1 !important',
    textDecoration: 'none !important',
  },
  groupBtn: {
    [useBreakpoints(theme).lessThan.lg]: {
      padding: '18px 42px',
      lineHeight: 1.12,
    },
  },
  messageRow: {
    '&.bubble-contact': {
      '& .bubble': {
        backgroundColor: '#eaf4f8', //theme.palette.primary.main,
        color: '#000', //theme.palette.primary.contrastText,
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
        '& .time': {
          marginLeft: 12,
        },
      },
      '&.first-of-group': {
        paddingTop: '2.0rem',
        '& .bubble': {
          borderTopLeftRadius: 5,
        },
      },
      '&.last-of-group': {
        '& .bubble': {
          borderBottomLeftRadius: 5,
        },
      },
    },
    '&.bubble-me': {
      paddingLeft: 40,

      '& .avatar': {
        order: 2,
        margin: '0 0 0 16px',
      },
      '& .bubble': {
        marginLeft: 'auto',
        backgroundColor: '#0073b1', //theme.palette.grey[300],
        color: '#fff', //theme.palette.getContrastText(theme.palette.grey[300]),
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
        '& .time': {
          justifyContent: 'flex-end',
          right: 0,
          marginRight: 12,
        },
      },
      '&.first-of-group': {
        paddingTop: '2.0rem',
        '& .bubble': {
          borderTopRightRadius: 5,
        },
      },

      '&.last-of-group': {
        '& .bubble': {
          borderBottomRightRadius: 5,
        },
      },
    },
    '&.bubble-admin': {
      '& .bubble': {
        backgroundColor: '#f2f2f2', //theme.palette.primary.main,
        color: '#000', //theme.palette.primary.contrastText,
        borderTopLeftRadius: 5,
        borderBottomLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
        '& .time': {
          marginLeft: 12,
        },
      },
      '& .avatar': {
        order: 2,
        margin: '0 0 0 16px',
        borderWidth: 2,
        borderColor: '#187fb7',
        //borderTopLeftRadius: 1,
        borderStyle: 'solid',
      },
      '& .avatar-suspend': {
        order: 2,
        margin: '0 0 0 16px',
        borderWidth: 2,
        borderColor: '#707070',
        //borderTopLeftRadius: 1,
        borderStyle: 'solid',
      },
      '&.first-of-group': {
        paddingTop: '2.0rem',
        '& .bubble': {
          borderTopLeftRadius: 5,
        },
      },
      '&.last-of-group': {
        '& .bubble': {
          borderBottomLeftRadius: 5,
        },
      },
    },
    '&.bubble-contact + .bubble-me, &.bubble-me + .bubble-contact': {
      paddingTop: 20,
      marginTop: 20,
    },
    '&.first-of-group': {
      '& .bubble': {
        borderTopLeftRadius: 5,
        paddingTop: 13,
      },
    },
    '&.last-of-group': {
      '& .bubble': {
        borderBottomLeftRadius: 5,
        paddingBottom: 13,
        '& .time': {
          display: 'flex',
        },
      },
    },
  },
  chatForm: {
    '&.chat-form': {
      backgroundColor: '#f2f2f2',
    },
  },
  headerPanel: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  headerConversationsAction: {
    position: 'relative',
    margin: '10px 13px 5px auto',
  },
  headerActionPanel: {
    position: 'relative',
    marginLeft: 'auto',
  },
  moreIcon: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  moreWrapper: {
    position: 'absolute',
    right: 0,
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 9,
    boxShadow: '0 3px 6px 0 rgb(0 0 0 / 16%)',
    backgroundColor: '#fff',
    overflow: 'hidden',
    zIndex: 99,
  },
  moreItem: {
    padding: ' 11px 19px',
    cursor: 'pointer',
    borderBottom: '1px solid #70707036',
    '&:hover': {
      backgroundColor: '#70707036',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
    '&.disabled': {
      pointerEvents: 'none',
      color: '#9e9e9e',
    },
  },
}))
